import './SuccessfulApplication.scss';

import React, { useEffect, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import { useLocation, useNavigate } from 'react-router-dom';

import { FinishButton } from '../components/buttons/Buttons';
import checkMark from '../img/checkmark.png';
import validarAgente from '../img/exito.webp';
import useTrackEvent from '../utils/trackEvent';

const SuccessfulApplication = () => {
  const location = useLocation();
  const { estado } = location.state || {};
  const hasPushedPageView = useRef(false);
  const { pushCustomEvent } = useTrackEvent();
  const navigate = useNavigate();

  const finishHandleClick = () => {
    navigate('/');
  };

  useEffect(() => {
    if (!hasPushedPageView.current) {
      pushCustomEvent('vpv', {
        flujo: 'Refinanciamiento',
        step: '3',
        page: '/refinancia-tu-credito/solicitud-exitosa',
        PageName: 'Refinanciamiento - Éxito',
        estado,
        version: 'v2',
      });

      hasPushedPageView.current = true;
    }
  }, []);

  return (
    <>
      <div className="image-container">
        <img src={validarAgente} alt="Validar con agente" />
        <div className="checkmark-wrapper">
          <img src={checkMark} alt="CheckMark" width={110} />
        </div>
      </div>
      <div className="content-container">
        <h2>
          <strong style={{ color: '#1D364C' }}>¡Gracias por tu solicitud!</strong>
        </h2>
        {isMobile ? (
          <>
            <p>
              Estamos creando una propuesta que mejore tus condiciones actuales.
              <br />
              Te contactaremos muy pronto.
            </p>
          </>
        ) : (
          <>
            <p>Estamos creando una propuesta que mejore tus condiciones actuales.</p>
            <p>Te contactaremos muy pronto.</p>
          </>
        )}

        <FinishButton onClick={finishHandleClick} />
      </div>
    </>
  );
};

export default SuccessfulApplication;
